module.exports = __webpack_public_path__ + "static/school_obj3@2x-665cd84784618372db29a455e9988688.png";